import { createFileRoute } from '@tanstack/react-router';

import { ExecutiveSummaryPage } from '@/features/nis2/executive/ExecutiveSummaryPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/executive')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ExecutiveSummaryPage />
      </div>
    </div>
  );
}
